import { WebClient } from "./server/WebClient";
import PresenterPreferences from '../../src/entities/PresenterPreferences';

export const PresenterPreferencesService = {
    get: () => WebClient.Get<PresenterPreferences>('api/PresenterPreferences/GetPresenterPreferences'),    
    save: (preferences: PresenterPreferences) => WebClient.Post.Validated<PresenterPreferences>(`api/PresenterPreferences/SavePresenterPreferences/`, preferences)
}